<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="statisticTop">
        <div>
          <span>时间范围: </span>
          <a-range-picker @change="onChange" :value="dateArr" />
        </div>
        <div class="btnClass">
          <a-button type="primary" @click="statisticClick" class="btn"
            >统计</a-button
          >
          <a-button @click="resetClick" class="btn">重置</a-button>
        </div>
      </div>
      <div>
        <a-checkbox-group v-model="defaultValue" @change="checkChange">
          <a-checkbox
            :value="item.value"
            v-for="(item, index) in checkedList"
            :key="index"
          >
            {{ item.label }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
      <div class="chart-main" ref="chartInstance"></div>
    </div>
  </TitleCard>
</template>

<script>
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { msgPublic } from '@/api/systemUser'
export default {
  mixins: [mixinsBackStack],

  data() {
    return {
      tableValue: [],
      titleCard: '信息发布统计',
      dateArr: [],
      chartInstance: null,
      params: {
        msgPublicType: []
      },
      checkedList: [
        { label: '需求发布量', value: '0' },
        { label: '运营信息发布量', value: '1' },
        { label: '服务机构发布量', value: '2' }
      ],
      defaultValue: ['0', '1', '2'],
      xData: [],
      yData: []
    }
  },
  components: {},
  mounted() {
    this.getCounts()
    window.addEventListener('resize', () => this.resizeChart())
  },
  methods: {
    checkChange(val) {
      if (val.length === 0) {
        this.defaultValue = ['0']
      } else {
        this.defaultValue = val
      }

      this.getCounts()
    },
    async getCounts() {
      this.xData = []
      this.yData = []
      // if(this.dateArr[0]){
      //   this.params.beginTime = this.dateArr[0]
      // }
      // if(this.dateArr[1]){
      //   this.params.endTime = this.dateArr[1]
      // }

      // this.params.endTime = this.dateArr[1] || ''
      this.params.msgPublicType = this.defaultValue

      const { data } = await msgPublic(this.params, this.params)

      for (let i in data) {
        if (i === '0') {
          this.xData.push('需求发布量')
          this.yData.push(data[i])
        } else if (i === '1') {
          this.xData.push('运营信息发布量')
          this.yData.push(data[i])
        } else if (i === '2') {
          this.xData.push('服务机构发布量')
          this.yData.push(data[i])
        }
      }

      this.getChart()
    },
    getChart() {
      if (this.chartInstance) {
        this.chartInstance.dispose()
      }
      this.chartInstance = this.$echarts.init(this.$refs.chartInstance)
      let option = {
        tooltip: {
          textStyle: {
            align: 'left'
          }
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {},
            saveAsImage: {
              name: '信息发布统计'
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },

        xAxis: [
          {
            type: 'category',
            data: this.xData,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单位:个',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#666'
              }
            }
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '50',
            itemStyle: {
              barBorderRadius: [100, 100, 0, 0],
              color: function(params) {
                let colorList = [
                  '#c23531',
                  '#2f4554',
                  '#61a0a8',
                  '#d48265',
                  '#91c7ae',
                  '#749f83',
                  '#ca8622',
                  '#bda29a',
                  '#6e7074',
                  '#546570',
                  '#c4ccd3',
                  '#4BABDE',
                  '#FFDE76',
                  '#E43C59',
                  '#37A2DA'
                ]
                return colorList[params.dataIndex]
              }
            },

            label: {
              show: true,
              position: 'top'
            },
            data: this.yData
          }
        ]
      }
      this.chartInstance.setOption(option)
      // 下面的是自适应屏幕大小去缩放
      this.$nextTick(() => {
        setTimeout(() => this.resizeChart(), 500)
      })
    },
    onChange(date, dateString) {
      this.dateArr = date
      this.params.beginTime = dateString[0]
      this.params.endTime = dateString[1]
    },
    statisticClick() {
      this.getCounts()
    },
    resetClick() {
      this.dateArr = []
      this.params = {
        msgPublicType: []
      }
      this.defaultValue = ['1', '2', '0']
      this.getCounts()
    },
    resizeChart() {
      this.chartInstance.resize()
    }
  },
  beforeDestroy() {
    // eslint-disable-next-line no-unused-expressions
    this.chartInstance && this.chartInstance.dispose()
  }
}
</script>
<style lang="scss" scoped>
.statisticTop {
  width: 100%;
  display: flex;
  margin: 20px;
  .btnClass {
    margin-left: 20px;
    .btn {
      margin-left: 10px;
    }
  }
}
.chart-main {
  width: 100%;
  height: 50vh;
}
</style>
